import React from "react";
import "./index.css";
import { Button, Stack } from "react-bootstrap";
import { NavLink, useLocation } from "react-router-dom";
import { formatDateWithMonth } from "../../../../utils/helperFunction";
import { useSelector } from "react-redux";
import moment from "moment";
import KitImagePreview from "./KitImagePreview";
import ProductTableView from "../common/ProductTableView";
import ProductDetailsButtonView from "../common/ProductDetailsButtonView";
const KitDetails = () => {
  // main state for the form data
  const { quichReportData } = useSelector((state) => state.QUICKREPORT);
  const query = new URLSearchParams(useLocation().search);
  const reportType = query.get("report-type");
  const tableBody =
    quichReportData?.products?.length > 0
      ? quichReportData?.products?.map((item) => {
          return {
            cell: [
              {
                data: <h6 className="mb-0">{item?.description}</h6>,
                align: "start",
              },
              {
                data: <h6 className="mb-0">{item?.current_quantity}</h6>,
                align: "center",
              },
              {
                data: (
                  <h6 className="mb-0">
                    {item?.expiry_date &&
                      moment(item.expiry_date).format("MMM YYYY")}
                  </h6>
                ),
                align: "center",
              },
            ],
          };
        })
      : [];

  return (
    <Stack className="justify-content-between">
      <div className="open-sans-font incident-report-container d-flex flex-column gap-3">
        <div className="d-flex justify-content-center">
          <KitImagePreview url={quichReportData?.kit_data?.kit_picture} />
        </div>
        <h6 className="fw-bold text-center text-break">
          {quichReportData?.kit_data?.brand}&nbsp;
          {quichReportData?.kit_data?.model_number}&nbsp;
          {quichReportData?.kit_data?.product_name}
        </h6>
        <ProductDetailsButtonView />
        <ProductTableView
          tableHeader={[
            { name: "Kit Contents", align: "left" },
            { name: "Quantity", align: "center" },
            { name: "Expiry Date", align: "center" },
          ]}
          tableBody={tableBody}
        />
      </div>
      <div className="incident-report-form-footer-action">
        <NavLink to="/standardwithquickreport">
          <Button variant="dark fw-bold h-100" type="button">
            Cancel
          </Button>
        </NavLink>
        <NavLink
          to={
            reportType === "standard-report"
              ? "/detailedreportinfo"
              : reportType === "quick-report"
              ? "/quickreportinfo"
              : "/standardwithquickreport"
          }
        >
          <Button
            variant="primary"
            type="button"
            className="button_custom fw-bold text-black"
          >
            Continue
          </Button>
        </NavLink>
      </div>
    </Stack>
  );
};

export default KitDetails;
